import { AccountBalance, ContactPhone, Email, Home, LocationCity, Numbers, Source } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

/**
 * The list of contact fields to display.
 * @type {Array<{label: string, icon: any, field: string}>}
 */
const contactFields = [
	{
		label: 'Source',
		icon: Source,
		field: 'source',
	},
	{
		label: 'Outbound Caller ID',
		icon: ContactPhone,
		field: 'outboundCallerId',
	},
	{
		label: 'Email',
		icon: Email,
		field: 'email',
	},
	{
		label: 'Address 1',
		icon: Home,
		field: 'address1',
	},
	{
		label: 'Address 2',
		icon: Home,
		field: 'address2',
	},
	{
		label: 'City',
		icon: LocationCity,
		field: 'city',
	},
	{
		label: 'State',
		icon: AccountBalance,
		field: 'state',
	},
	{
		label: 'ZIP Code',
		icon: Numbers,
		field: 'zip',
	},
];

/**
 * A pane displaying contact information.
 *
 * @param {Object} props The component props.
 * @param {Object} props.contact The contact to display information for.
 */
export function ContactInfoPane({ contact }) {
	return (
		<>
			<Typography variant="h6" textAlign="center" gutterBottom>Contact Fields</Typography>
			<Box
				display="grid"
				gridTemplateColumns={{
					xs: "1fr 1fr",
					sm: "1fr 1fr 1fr",
					md: "1fr 1fr 1fr 1fr"
				}}
				justifyItems="center"
				gap={2}
			>
				{contactFields.map(({ label, icon: Icon, field }) => {
					return (
						<Box key={field} display="grid" gridTemplateRows="auto 1fr" sx={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
							<Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" gap={1}>
								<Icon fontSize="small" color="primary" />
								<Typography variant="caption">{label}</Typography>
							</Box>
							<Typography
								variant="body1"
								sx={{
									textAlign: 'center'
								}}>
								{contact[field] ?? '—'}
							</Typography>
						</Box>
					);
				})}
			</Box>
		</>
	);
}
